import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getRoles() {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/roles", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching roles"
                    });
                }
            });
    },
    getRoleInfo(roleName) {
        var msgType = "updateSuccess";
        return axios.get(constants.BASE_URL + "/roles/" + roleName, {
            withCredentials: true
        }).then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "updateError";
            })
            .finally(() => {
                if (msgType == 'updateError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching role"
                    });
                }
            });
    }, saveRole(dto) {
        axios.defaults.withCredentials = true;
        return axios.put(constants.BASE_URL + "/roles", dto).then(response => {
            return response.data;

        }).catch(error => {
            EventBus.$emit('error-notification', {
                "msg": 'Error while saving Role'
            });
        });
    }
}
